import { useEffect, useState } from 'react';
import {
  CYCLE_STATUS_TO_TAB_NUMBER,
  LIVE_CHART_DATA_TYPE,
  NO_TAB_SELECTED,
  STATIC_CHART_DATA_TYPE,
  TAB_NUMBER,
  TAB_NUMBER_TO_TYPE,
} from '../../constants';
import { useAppDispatch } from '../../../../../store/store';
import CycleStatus from '../../../../../enums/cycle-status.enum';

export interface ICycleChartDataTabsInteractor {
  isLoading: boolean;
  isCompleted: boolean;

  activeTab: number;
  onChangeTab: (value: number) => void;

  staticTabNumber: number;
  liveTabNumber: number;
}

export interface CycleChartDataTabsInteractorProps {
  cycleId: string;
}

const staticTabNumber = TAB_NUMBER[STATIC_CHART_DATA_TYPE];
const liveTabNumber = TAB_NUMBER[LIVE_CHART_DATA_TYPE];

export const useCycleChartDataTabsInteractor = (
  props: CycleChartDataTabsInteractorProps,
): ICycleChartDataTabsInteractor => {
  const { cycleId } = props;
  const [activeTab, setActiveTab] = useState<number>(NO_TAB_SELECTED);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isCompleted, setIsCompleted] = useState(false);

  const {
    cycles: { getOne: getCycleById },
  } = useAppDispatch();

  const onChangeActiveTab: ICycleChartDataTabsInteractor['onChangeTab'] = (value: number) => {
    if (!(value in TAB_NUMBER_TO_TYPE)) {
      return;
    }

    setActiveTab(value);
  };

  const getCycleData = async (cycleId: string) => {
    try {
      setIsLoading(true);
      const cycle = await getCycleById(cycleId);

      if (cycle?.status) {
        const tab = CYCLE_STATUS_TO_TAB_NUMBER[cycle.status];
        setActiveTab(tab);
        setIsCompleted(cycle.status === CycleStatus.Completed);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getCycleData(cycleId);
  }, [cycleId]);

  return {
    isLoading,
    isCompleted,

    activeTab,
    onChangeTab: onChangeActiveTab,

    staticTabNumber,
    liveTabNumber,
  };
};
